import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { ArchiveState } from '@app-types/enums/archiving';
import { TransformEmailListItemContract } from '@app-types/api/email';
import { EmailState } from '@app-types/enums/email-state';
import { ARCHIVE_STATE_LABEL } from '@app-shared/constants/archive';

@Component({
  selector: 'app-archive-state-cell',
  templateUrl: './archive-state-cell.component.html',
  styleUrls: ['./archive-state-cell.component.scss'],
  imports: [TranslateModule, MatTooltip, NgClass],
})
export class ArchiveStateCellComponent {
  @Input() email: TransformEmailListItemContract;
  public EmailState = EmailState;

  public archivingIcons: Record<
    ArchiveState,
    {
      icon: string;
      class: string;
      tooltip: string;
    }
  > = {
    [ArchiveState.Off]: {
      icon: 'encrypted_off',
      class: 'button-waiting',
      tooltip: ARCHIVE_STATE_LABEL[ArchiveState.Off],
    },
    [ArchiveState.NotReadyToCheck]: {
      icon: 'arming_countdown',
      class: 'button-waiting',
      tooltip: ARCHIVE_STATE_LABEL[ArchiveState.NotReadyToCheck],
    },
    [ArchiveState.ReadyToCheck]: {
      icon: 'arming_countdown',
      class: 'button-waiting',
      tooltip: ARCHIVE_STATE_LABEL[ArchiveState.ReadyToCheck],
    },
    [ArchiveState.Checking]: {
      icon: 'safety_check',
      class: 'button-waiting',
      tooltip: ARCHIVE_STATE_LABEL[ArchiveState.Checking],
    },
    [ArchiveState.Archiving]: {
      icon: 'safety_check',
      class: 'button-waiting',
      tooltip: ARCHIVE_STATE_LABEL[ArchiveState.Archiving],
    },
    [ArchiveState.Archived]: {
      icon: 'verified_user',
      class: 'button',
      tooltip: ARCHIVE_STATE_LABEL[ArchiveState.Archived],
    },
    [ArchiveState.Error]: {
      icon: 'gpp_bad',
      class: 'button-error',
      tooltip: ARCHIVE_STATE_LABEL[ArchiveState.Error],
    },
    [ArchiveState.NotArchived]: {
      icon: 'gpp_bad',
      class: 'button-waiting',
      tooltip: ARCHIVE_STATE_LABEL[ArchiveState.NotArchived],
    },
  };

  constructor() {}

  get archiveIcon(): string {
    return !!this.email?.externalArchiveState ||
      this.email.externalArchiveState === ArchiveState.NotReadyToCheck
      ? this.archivingIcons[this.email.externalArchiveState].icon
      : 'arming_countdown';
  }

  get archiveTooltip(): string {
    return !!this.email?.externalArchiveState ||
      this.email.externalArchiveState === ArchiveState.NotReadyToCheck
      ? this.archivingIcons[this.email.externalArchiveState].tooltip
      : 'awaitingArchive';
  }

  get archiveClass(): string {
    return this.email.externalArchiveState ||
      this.email.externalArchiveState === ArchiveState.NotReadyToCheck
      ? this.archivingIcons[this.email.externalArchiveState].class
      : 'button-waiting';
  }
}
